import { api } from '@/lib/api';

export const pushApi = {
  vapidKey() { return api.get('/push/vapid-public-key'); },
  status() { return api.get('/push/status'); },
  subscribe(subscription) { return api.post('/push/subscribe', { subscription }); },
  unsubscribe(endpoint = null) { return api.post('/push/unsubscribe', { endpoint }); },
};
